import React, { Fragment } from 'react';
export function TickerStrip() {
  const services = ['Ant Control', 'Spider Treatment', 'Rodent Exclusion', 'Mosquito Defense', 'Roach Elimination', 'Wasp & Bee Removal', 'Scorpion Control'];
  // Duplicate for seamless loop
  const tickerItems = [...services, ...services, ...services];
  return <div className="bg-brand-green py-3 overflow-hidden flex whitespace-nowrap border-y border-black" data-id="element-283">
      <div className="flex animate-marquee items-center" data-id="element-284">
        {tickerItems.map((service, index) => <Fragment key={index} data-id="element-285">
            <span className="font-condensed uppercase font-bold text-black text-2xl tracking-wider mx-6" data-id="element-286">
              {service}
            </span>
            <span className="text-black text-xl font-bold" data-id="element-287">·</span>
          </Fragment>)}
      </div>
    </div>;
}